import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  clientId: number
  enabled?: boolean
}

export default function useSingleClient({clientId, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    queryKey: [QueryKeyEnum.CLIENT, clientId],
    initialData: null,
    queryFn: async () => (await api.client.getById(clientId)).data.data,
  })

  return query
}
